<template>
    <div>
        <div class="breadcrumb_section bg_gray page-title-mini">
            <div class="container"><!-- STRART CONTAINER -->
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="page-title">
                            <h1>{{ randomPrice.title }}</h1>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <ol class="breadcrumb justify-content-md-end">
                            <li class="breadcrumb-item"><a :href="route('home',{ domain : website.domain } )">Home</a></li>
                            <li class="breadcrumb-item active">{{ randomPrice.title }}</li>
                        </ol>
                    </div>
                </div>
            </div><!-- END CONTAINER-->
        </div>
        <div class="container pt-5"><!-- STRART CONTAINER -->
          <div class="row rounded bg_light_blue pt-3">
            <h3 class="mr-2 ml-4">Thông tin: </h3>
            <div class="p-3" v-html="randomPrice.content"></div>
          </div>
        </div>

        <!-- START MAIN CONTENT -->
        <div class="main_content">

            <!-- START SECTION SHOP -->
            <div class="section">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="row shop_container" v-if="accountDataSet.data.length > 0">
                                <div class="col-lg-3 col-md-4 col-6 grid_item" v-for="account in accountDataSet.data"
                                     :key="account.id"
                                     :id="account.id">
                                    <div class="product_box  text-center">
                                        <div class="product_img">
                                            <img :src="randomPrice.thumbnail" :alt="'Account '+ randomPrice.title">
                                        </div>
                                        <div class="product_info">
                                            <h6 class="product_title">
                                                {{ randomPrice.title }}
                                            </h6>
                                            <div class="product_price text-center">
                                                <span class="regular_price text-danger"> {{
                                                        Helper.formatMoney(randomPrice.regular_price)
                                                    }}<sup>đ</sup></span>
                                                <span class="price text-success"> {{
                                                        Helper.formatMoney(randomPrice.price)
                                                    }}<sup>đ</sup></span>
                                            </div>
                                            <div class="add-to-cart">
                                                <a class="btn btn-fill-out btn-radius"
                                                   @click="buySubmit(account)" target="_blank">Thử vận may</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="pagination mt-3 justify-content-center pagination_style1">
                                        <b-pagination
                                            v-model="accountDataSet.current_page"
                                            :total-rows="accountDataSet.total"
                                            :per-page="accountDataSet.per_page"
                                            first-number
                                            last-number
                                            page-class="mr-1"
                                            next-class="mr-1"
                                            prev-class="mr-1"
                                            last-class="mr-1"
                                            align="center"
                                            @change="handlePaginate"
                                        >
                                            <template v-slot:page="{ page, active }" class="page-link">
                                                <b v-if="active">{{ page }}</b>
                                                <i v-else>{{ page }}</i>
                                            </template>
                                        </b-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- END SECTION SHOP -->
    </div>
</template>
<script>
export default {
    props: {
        user: {
            Type: Object,
            default() {
                return {};
            }
        },
        accounts: {
            Type: Object,
            data() {
                return {}
            }
        },
        randomPrice: {
            Type: Object,
            data() {
                return {}
            }
        },
        website: {
            Type: Object,
            data() {
                return {}
            }
        }
    },
    data() {
        return {
            accountDataSet: this._.clone(this.accounts),
        }
    },
    methods: {
        async handlePaginate(page) {
            let params = {
                domain: this.website.domain,
                random: this.randomPrice.slug,
                page: 1

            };
            if (page > 1) {
                params.page = page;
            }
            const uri = this.route('fe.view_random_price', params);
            let response = await this.Request.get(uri);
            this.accountDataSet = this._.clone(response.data);

            this.$scrollTo('#head_page', 200);
        },

        async handleBuyAccount() {
            try {
                const uri = this.route('fe_buy_random', {domain: this.website.domain});
                const response = await this.Request.post(uri,{price: this.randomPrice.id});
                if (response.data.status === false) {
                    await this.$swal.fire({
                        title: 'Có lỗi xảy ra!',
                        text: response.data.message,
                        icon: 'error'
                    });
                } else {
                    await this.$swal.fire({
                            icon: 'success',
                            title: 'Thành Công',
                            html: response.data.message,
                        }
                    );
                    window.location.href = this.route('randomHistory', {domain: this.website.domain});
                }
            } catch (e) {
                console.log(e); // eslint-disable-line
                const errorMessages = this.Request.errors(e.response);
                await this.$swal({
                    icon: 'error',
                    title: 'Error',
                    text: this._.isEmpty(errorMessages) ? e.response.data.error : errorMessages[0],
                });
            }
        },

        async buySubmit() {
            await this.$swal.fire({
                title: 'Bạn có chắc muốn mua tài khoản này ?!',
                imageUrl: this.randomPrice.thumbnail,
                html: this.randomPrice.content,
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: `Mua ngay`,
                denyButtonText: `Huỷ`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.handleBuyAccount();
                }
            })
        }

    }
}
</script>

<style scoped>
.ribbon:nth-child(even) {
    margin-right: 4%;
}

@media (max-width: 500px) {
    .ribbon {
        width: 100%;
    }

    .ribbon:nth-child(even) {
        margin-right: 0%;
    }
}

.ribbon4 {
    position: absolute;
    padding: 8px 10px;
    background: #dc3545;
    box-shadow: -1px 2px 3px rgba(0, 0, 0, .3);
}

.ribbon4:before, .ribbon4:after {
    content: "";
    position: absolute;
}

.ribbon4:before {
    width: 7px;
    height: 100%;
    top: 0;
    left: -6.5px;
    padding: 0 0 7px;
    background: inherit;
    border-radius: 5px 0 0 5px;
}

.ribbon4:after {
    width: 5px;
    height: 5px;
    bottom: -5px;
    left: -4.5px;
    background: lightblue;
    border-radius: 5px 0 0 5px;
}
</style>
